import {Component, ComponentFactoryResolver, EventEmitter, OnInit, Output} from '@angular/core';
import {
    DASHBOARD_SETTINGS_COMPONENT,
    FORM_SETTINGS_COMPONENT,
    GENERAL_SETTINGS_COMPONENT,
    VIEW_SETTINGS_COMPONENT
} from '../../SettingsUtility';
import {faSearch} from '@fortawesome/free-solid-svg-icons';


@Component({

    selector: 'smart-main-setting-component',
    templateUrl: './main-setting-component.component.html',
    styleUrls: ['./main-setting-component.component.css']
})


export class MainSettingComponentComponent implements OnInit {
    @Output() eventEmitter = new EventEmitter<string>();
    faSe = faSearch;

    resolver: ComponentFactoryResolver;

    ngOnInit() {
    }


    onClick(value: string) {
        if (value === 'dashboard') {
            this.eventEmitter.emit(DASHBOARD_SETTINGS_COMPONENT.name);
        }
        if (value === 'view') {
            this.eventEmitter.emit(VIEW_SETTINGS_COMPONENT.name);
        }
        if (value === 'form') {
            this.eventEmitter.emit(FORM_SETTINGS_COMPONENT.name);
        }
        if (value === 'general') {
            this.eventEmitter.emit(GENERAL_SETTINGS_COMPONENT.name);
        }
    }
}
